const data = {
  messages: [],
};
export function MessageStoreReducer(state = data, { type, payload }) {
  switch (type) {
    case "PreviousChat": {
      return {
        ...state,
        messages: payload,
      };
    }

    case "NewChat": {
      
      return {
        ...state,
        messages:[...state.messages,payload],
      };

    }

    default: {
      return state;
    }
  }
}
